import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';


class projectMitigations {
  id : number;
  description : string;
  mitigationsStateId : number;
  calification : string;
  usersId : number;
  name : string;
  username : string;
  dateAccion : string;
  dateMitigation : string;
  projects_id : number;
  color : string;
}

@Component({
  selector: 'app-risk-mitigations',
  templateUrl: './risk-mitigations.component.html',
  styleUrls: ['./risk-mitigations.component.scss']
})
export class RiskMitigationsComponent implements OnInit, AfterViewInit ,OnDestroy {

  id:number;
  projectMitigations : projectMitigations[] = [];
  idMatrix : number;

  @ViewChild(DataTableDirective, { static: false })
  dtElement : DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};

  private apiService : ApiServiceProject;
  constructor(
    private http : HttpClient,
    private router: Router,
    private route : ActivatedRoute,
    private spinner : NgxSpinnerService,
    private errorService:ErrorService
  ) {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
      this.idMatrix = params['idMatrix'];
    });
   }

  ngOnInit(): void {

    this.dtOptions = FormatDataTableGlobal();
    this.apiService = new ApiServiceProject(this.http)
    this.spinner.show();
    this.apiService
    .getService('list-project-view-mitigations?id='+this.idMatrix)
    .subscribe({
      next: (rs: any) => {
        if (rs) {
          this.spinner.hide();
          this.projectMitigations = rs;
          this.spinner.hide();
          this.rerender();
        } else {
          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });
  }

  mitigationDelete(id:any){
    Swal.fire({
      title: 'Eliminar',
      text: '¿Desea eliminar mitigacion',
      icon: 'warning',
      showCancelButton:true,
      confirmButtonText: 'Aceptar',
      cancelButtonText:"No, cancelar",
      heightAuto: false
    }).then((res) => {
      if (res.isConfirmed) {
        this.spinner.show()
        this.apiService.deleteService('project-view-mitigations-delete?id=' + id).subscribe({
          next: (rs: any) => {
            if (rs) {
              this.spinner.hide();
              Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
              
            } else {
                this.spinner.hide();
                Swal.fire({
                title:  rs.error,
                text: '',
                icon: 'error',
                heightAuto: false
                }); } },
          error: (error) => {
            this.errorService.error(error);
          },});
      }
      else if ( res.dismiss === Swal.DismissReason.cancel){
        Swal.fire({
          title: 'Cancelado',
          text: 'Operación cancelada.',
          icon: 'error',
          heightAuto: false
        })

      }
    });

  }
  
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  riskEdit(id: any, idMatrix: any, item: any){

    localStorage.setItem("info-mtn", JSON.stringify(item));
    this.router.navigateByUrl('/pdg/project/'+id+'/'+idMatrix+'/risk/mitigations/update');
    
  }
  
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
